import React from 'react'

/*
  Font Awesome toggle helper
  fa-lock, fa-unlock
  fa-angle-right, fa-angle-down
*/

export default ({opened, openedClass, closedClass, onClick}) => {
  const className = `score-toggle fas clickable ${!opened ? closedClass : openedClass} ${!opened ? 'closed' : 'open'}`;
  return(<span onClick={onClick} className={className} />);
};
